<template>
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="设备编号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.imei"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.deviceName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">打卡时间</span>
          <el-date-picker
            size="mini"
            v-model="expirationTime"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #serial="slotData">
        <p>{{ slotData.data.row.serial }}</p>
      </template>
      <template #onDutyCoord="slotData">
        <p v-if="slotData.data.row.valueResVO.dutyOn_lng">{{ slotData.data.row.valueResVO.dutyOn_lng + "," + slotData.data.row.valueResVO.dutyOn_lat }}</p>
        <p v-else></p>
      </template>
      <template #offDutyCoord="slotData">
        <p v-if="slotData.data.row.valueResVO.dutyOff_lng">{{ slotData.data.row.valueResVO.dutyOff_lng + "," + slotData.data.row.valueResVO.dutyOff_lat }}</p>
        <p v-else></p>
      </template>
    </e-table>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { filterObj } from '@/utils/util';
import { postAction } from "@/api/manage";
export default {
  name: "deviceList",
  components: { eTable },
  mixins: [listMixin],
  created() {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  computed: {},
  watch: {},
  data() {
    return {
      url: {
        list: "/tqClockIn/queryPage",
      },
      queryParam: {},
      expirationTime: '',
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      dateDefaultShow: "",
      columns: [
        {
          field: "serial",
          label: "序号",
          width: 50,
          columnType: "slot",
          slotName: "serial",
        },
        {
          field: "imei",
          fixed: "left",
          label: "设备编号",
        },
        {
          field: "deviceName",
          label: "设备名称",
        },
        {
          field: "valueResVO.dutyOn",
          label: "上班打卡",
        },
        {
          field: "valueResVO.dutyOff",
          label: "下班打卡",
        },
        {
          // field: "userName",
          label: "经度/纬度(上班)",
          columnType: "slot",
          slotName: "onDutyCoord",
        },
        {
          // field: "userName",
          label: "经度/纬度(下班)",
          columnType: "slot",
          slotName: "offDutyCoord",
        },
        {
          field: "valueResVO.hour",
          label: "工时(h)",
        },
        {
          field: "valueResVO.addressOn",
          label: "上班打卡地址",
        },
        {
          field: "valueResVO.addressOff",
          label: "下班打卡地址",
        },
      ],
      deviceList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    dateChange(date) {
      if (date) {
        this.queryParam.startTime = date[0]
        this.queryParam.endTime = date[1]
      } else {
        this.queryParam.startTime = "";
        this.queryParam.endTime = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.expirationTime = "";
      this.searchQuery();
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();
      this.loading = true;
        postAction(this.url.list, params).then((res) => {
          if (res.msg) {
            this.$message.warning(res.msg);
            return;
          }
          res.data.records.forEach((item, index) => (item.serial = index + 1));
          this.dataSource = res.data.records
          if (res.data.total) {
            this.ipagination.total = res.data.total;
          } else {
            this.ipagination.total = 0;
          }
          this.loading = false;
        });
    },
    getQueryParams() {
      var param = Object.assign(this.queryParam, this.isorter, this.filters);
      param.page = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      param.childFlag = 0;
      param.filter = 0;
      return filterObj(param);
    },
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
